import { render, staticRenderFns } from "./CompanyEntities.vue?vue&type=template&id=737acb72&"
import script from "./CompanyEntities.vue?vue&type=script&lang=js&"
export * from "./CompanyEntities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports